import React from 'react';

/**
 * Ported verbatim from the Vue ERP's `src/components/icons/IconSearch.vue`.
 * Used by the mobile header search toggle (`HeaderIndex`), the
 * Category & Collection selectors and CloseHub's shared
 * `SearchInput.tsx`.
 */
interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconSearch: React.FC<IconProps> = ({
  size = 16,
  className,
  ariaHidden = true,
  ariaLabel,
}) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xmlSpace="preserve"
        width={size}
        height={size}
        className={className}
        aria-hidden={ariaHidden ? true : undefined}
        aria-label={ariaLabel}
      >
        <path
          d="M443.5,420.2L336.7,312.4c20.9-26.2,33.5-59.4,33.5-95.5c0-84.5-68.5-153-153.1-153S64,132.5,64,217s68.5,153,153.1,153
          c36.6,0,70.1-12.8,96.5-34.2l106.1,107.1c3.2,3.4,7.6,5.1,11.9,5.1c4.1,0,8.2-1.5,11.3-4.5C449.5,437.2,449.7,426.8,443.5,420.2z
          M217.1,337.1c-32.1,0-62.3-12.5-85-35.2c-22.7-22.7-35.2-52.9-35.2-84.9c0-32.1,12.5-62.3,35.2-84.9c22.7-22.7,52.9-35.2,85-35.2
          c32.1,0,62.3,12.5,85,35.2c22.7,22.7,35.2,52.9,35.2,84.9c0,32.1-12.5,62.3-35.2,84.9C279.4,324.6,249.2,337.1,217.1,337.1z"
          fill="currentColor"
        />
      </svg>
  );
};

export default IconSearch;
